export default "__VITE_ASSET__0Yo59Fcr__"